import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";

import AdminLayout from "Layouts/Admin";
import AuthLayout from "Layouts/Auth";
import { InitialRenderPage } from "Screens/Admin/Common/InitialRender";
import PageNotFound from "Screens/Admin/Common/NotFound";

import { validateToken } from "./utils/checkToken";
import RestrictedAccess from "../src/Common Usage/RestrictedAccess";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    async function verify() {
      const result = await validateToken();

      if (!result.valid) {
        localStorage.clear();
        navigate("/auth/sign-in");
      }
    }
    if (location.pathname.startsWith("/admin")) {
      verify();
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="/" element={<InitialRenderPage />} />
      <Route path="/404" element={<PageNotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
      <Route path="/restricted" element={<RestrictedAccess />} />
    </Routes>
  );
};

export default App;

